// src/services/api.ts

import { User } from "../types/auth"; // Import User type

/**
 * Generates the Authorization header with the JWT token.
 * Assumes the user object is stored in localStorage.
 */
export function authHeader(): { Authorization?: string } {
  const userStr = localStorage.getItem("user");
  let user: User | null = null;
  if (userStr) {
    try {
      user = JSON.parse(userStr) as User;
    } catch (e) {
      console.error("Failed to parse user from localStorage", e);
      localStorage.removeItem("user"); // Clear invalid data
    }
  }

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
}
